import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject
} from '@angular/core';
import { forkJoin } from 'rxjs';
import { WidgetPanelCounts } from 'src/app/interfaces/widget-panel-counts';
import { ApConfigService } from 'src/app/services/ap-config.service';
import { ComplianceService } from 'src/app/services/compliance.service';

@Component({
  selector: 'app-api-errors-widget',
  templateUrl: './api-errors-widget.component.html',
  styleUrls: ['./api-errors-widget.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ApiErrorsWidgetComponent {
  private _cdr = inject(ChangeDetectorRef);
  apiErrors: WidgetPanelCounts['data'] = new Map([]);

  widgetPanelCounts: WidgetPanelCounts = {
    title: 'API Errors',
    hasData: false,
    data: this.apiErrors
  };

  constructor(
    private ComplianceService: ComplianceService,
    private ApConfigService: ApConfigService
  ) {
    const currentDate: Date = new Date();
    const twentyFourHoursAgo: Date = new Date(
      currentDate.setHours(currentDate.getHours() - 24)
    );

    const getAccountingSyncApiErrorsCount24Hours = {
      lastVendorSync: JSON.stringify({
        $lte: twentyFourHoursAgo
      })
    };

    forkJoin([
      this.ComplianceService.getBusinessVerificationApiErrorsNotResolvedCount(),
      this.ApConfigService.getApConfigCount(
        getAccountingSyncApiErrorsCount24Hours
      )
    ]).subscribe({
      next: ([
        businessVerificationApiErrorsNotResolvedCount,
        accountingSyncApiErrorsCount24Hours
      ]) => {
        this.apiErrors.set('Active Business Verification API Errors', {
          count: Number(businessVerificationApiErrorsNotResolvedCount),
          route: '/admin/dashboard/businessVerificationApiErrors'
        });
        this.apiErrors.set('Ap Systems Not Synced for 24 Hours or More', {
          count: Number(accountingSyncApiErrorsCount24Hours),
          query: getAccountingSyncApiErrorsCount24Hours,
          route: '/admin/dashboard/apSystems'
        });
        this._cdr.markForCheck();
      }
    });
  }
}
